<template>
  <div>
    <van-nav-bar title="下发记录" left-arrow @click-left="onClickLeft" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index">
        <div class="item">
          <div>
            <span class="title">设备名称：</span>
            <span>{{ item.deviceName }}</span>
          </div>
          <div>
            <span class="title">姓名：</span>
            <span>{{ item.personName }}</span>
          </div>
          <div>
            <span class="title">性别：</span>
            <span>{{ item.personSexName }}</span>
          </div>
          <div>
            <span class="title">身份证号：</span>
            <span>{{ item.personCardNo }}</span>
          </div>
          <div>
            <span class="title">地址：</span>
            <span>{{ item.houseAddress||'--' }}</span>
          </div>
          <div>
            <span class="title">同步类型：</span>
            <span>{{ item.syncTypeName }}</span>
          </div>
          <div>
            <span class="title">同步结果：</span>
            <span>{{ item.syncResultName }}</span>
          </div>
          <div>
            <span class="title">同步状态：</span>
            <span v-if="item.isSuccess == '0'" style="color: #67c23a">{{
              item.isSuccessName
            }}</span>
            <span v-else style="color: #f56c6c">{{ item.isSuccessName }}</span>
          </div>
          <div>
            <span class="title">创建时间：</span>
            <span>{{ item.createTime }}</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      cardNo: "",
      page: 1,
    };
  },
  mounted() {
    this.getByRIdDetail();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async getByRIdDetail() {
      let res = await this.get(
        "api-apmuc/personHouseRelationRest/byRIdDetail/",
        this.$route.query.id
      );
      if (res && res.status == 0) {
        this.cardNo = res.data.cardNo;
        this.onLoad();
      }
    },
    onLoad() {
      if (this.cardNo == "") return;
      let param = {
        page: this.page,
        pageSize: 10,
        personCardNo: this.cardNo,
        entrance:'h5'
      };
      this.post("apmdev-server/issueSyncResult/queryUniq", param).then(
        (res) => {
           let result =  res.data||[]
           result.forEach(item=>{
            item.personCardNo = item.personCardNo.replace(/(\w{1})\w*(\w{1})/, '$1**************$2');
           })
          this.list = this.list.concat(result);
          this.loading = false;
          if (this.list.length >= res.total) {
            this.finished = true;
          } else {
            this.finished = false;
            this.page++;
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.item {
  margin-bottom: 10px;
  font-size: 14px;
  padding: 10px;
  /* border-bottom: 1px solid #eee; */

  box-shadow: 0px 0px 10px 0px rgba(43, 133, 228, 0.15);
}
.title {
  font-weight: bold;
}
</style>